import { useState } from 'react'

export const useForm = (initial) => {
  const [form, setForm] = useState(initial)
  const [errors, setErrors] = useState({})

  const setField = (field, value) => {
    setForm((current) => ({ ...current, [field]: value }))
    setErrors({})
  }

  return { form, setForm, errors, setErrors, setField }
}
